import { render, staticRenderFns } from "./resultInput.vue?vue&type=template&id=1508f6e4&scoped=true&"
import script from "./resultInput.vue?vue&type=script&lang=js&"
export * from "./resultInput.vue?vue&type=script&lang=js&"
import style0 from "./resultInput.vue?vue&type=style&index=0&id=1508f6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508f6e4",
  null
  
)

export default component.exports